var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-layout-container ui-layout-flex ui-layout-flex--column ui-height-100"},[_c('iframe',{staticClass:"ui-height-100",attrs:{"src":_vm.getImpotUrl,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }